export const CATEGORIES = [
  "All",
  "Electronics",
  "Vehicles",
  "Furniture",
  "Real Estate",
  "Books",
  "Other",
];
